import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../Util/Session/session.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeaveMasterService {

  constructor(private http: HttpClient,
    private session: SessionService,) {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
     }

  LeaveMasterUpdate(LeaveMaster: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LeaveMaster/Update`,
      this.session.SetClass(LeaveMaster)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  LeaveMasterSelect(LeaveMaster: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LeaveMaster_Select/Get`,
      this.session.SetClass(LeaveMaster)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
